import { Injectable } from '@angular/core';
import { CommandService } from './command.service';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class OpenService extends CommandService {
  constructor() {
    super(new ToastController());
  }

  sendMessage() {
    this.cmd = '3A21' + this.device.properties.config.totpKey;

    this.ble
      .write(
        this.device.bleId,
        this.device.serviceUUID,
        this.device.rxUUID,
        this.hexTobytes(this.cmd)
      )
      .then(
        (data) => {
          console.log('Ouverture de porte : Cmd envoyée.');
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public receiveResponse(data: any) {
    console.log(
      '[Réponse Ouverture de porte] : ',
      this.buf2hex(data).toLowerCase()
    );
    if (this.buf2hex(data).toLowerCase() == '3a01') {
      return true;
    }
    return false;
  }
}
